import FormInput from '../templates/FormInput';
import { FormItemProps } from '../templates/FormProps';

const PhoneNumber = ({
  name = 'phone',
  label = 'Phone Number',
  placeholder = 'Enter Phone Number',
  rules,
  // required = false,
  // enableRule = false,
  ...props
}: FormItemProps & {
  enableRule?: boolean;
}) => {
  // const { t } = useTranslation('Vindoc');

  // const rulesMemo = useMemo(() => {
  //   const rulesState: unknown[] = [
  //     {
  //       validator: (rule, value) => {
  //         if (!enableRule) return Promise.resolve();

  //         return phoneNumberValidator(rule, value, required, t);
  //       },
  //     },
  //   ];

  //   if (required) rulesState.push({ required: true, message: t(MESSAGE.INLINE.IEM_0001) });
  //   if (rules) rulesState.push(...rules);

  //   return rulesState;
  // }, [t, required, rules]);

  return <FormInput {...{ name, label, placeholder, ...props }} autoComplete="phone" />;
};

export default PhoneNumber;
